import topbar from "../../vendor/topbar";

export const configureTopbar = () => {
  topbar.config({ barColors: { 0: "#29d" }, shadowColor: "rgba(0, 0, 0, .3)" });
};

export const bindPageLoadingRuntime = () => {
  window.addEventListener("phx:page-loading-start", () => {
    try {
      const connected = !!(
        window.liveSocket &&
        window.liveSocket.isConnected &&
        window.liveSocket.isConnected()
      );

      if (navigator.onLine && connected) {
        topbar.show(300);
      } else {
        topbar.hide();
      }
    } catch (_) {
      topbar.hide();
    }
  });

  window.addEventListener("phx:page-loading-stop", () => topbar.hide());
};

export const bindConnectivityRuntime = () => {
  window.addEventListener('offline', () => {
    if (window.deviceConnection) return;
    try {
      topbar.hide();
      document.documentElement.classList.remove('phx-loading');
      document
        .querySelectorAll('.phx-click-loading, .phx-change-loading, .phx-submit-loading')
        .forEach((el) =>
          el.classList.remove('phx-click-loading', 'phx-change-loading', 'phx-submit-loading')
        );

      document.querySelectorAll('[disabled][data-kop-intent]').forEach((el) => {
        el.dataset.wasDisabled = '1';
        el.removeAttribute('disabled');
      });
    } catch (_) { }
  });

  window.addEventListener('online', () => {
    if (window.deviceConnection) return;
    try {
      document.querySelectorAll('[data-kop-intent][data-was-disabled="1"]').forEach((el) => {
        el.setAttribute('disabled', 'disabled');
        delete el.dataset.wasDisabled;
      });
    } catch (_) { }
  });
};

export const enableLiveViewDebug = (liveSocket) => {
  try {
    const explicitDebug = new URLSearchParams(window.location.search).get('lv_debug') === '1';
    const localhostDebug =
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1';

    if (liveSocket && (explicitDebug || localhostDebug)) {
      liveSocket.enableDebug();
    }
  } catch (_) { }
};

export const bindCloseDropdownRuntime = () => {
  window.addEventListener("phx:close_dropdown", (event) => {
    const dropdownId = event.detail?.dropdown_id;
    if (dropdownId) {
      const dropdown = document.getElementById(dropdownId);
      if (dropdown) {
        dropdown.blur();
        const dropdownContent = dropdown.parentElement.querySelector('.dropdown-content');
        if (dropdownContent) {
          dropdownContent.style.display = 'none';
          setTimeout(() => {
            dropdownContent.style.display = '';
          }, 100);
        }
      }
    } else {
      const activeDropdown = document.activeElement;
      if (activeDropdown && activeDropdown.closest('.dropdown')) {
        activeDropdown.blur();
      }
    }
  });
};

export const bindDownloadFileRuntime = () => {
  window.addEventListener('phx:download_file', (e) => {
    const { filename, content, mime_type } = e.detail;

    try {
      const byteCharacters = atob(content);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mime_type });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.style.display = 'none';
      anchor.href = url;
      anchor.download = filename;

      document.body.appendChild(anchor);
      anchor.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(anchor);
    } catch (error) {
      console.error('Failed to download file:', error);
      alert('Erro ao fazer download do arquivo');
    }
  });
};

const syncFullscreenButtonState = (button) => {
  if (!button) return;

  const enterIcon = button.querySelector('[data-role="fullscreen-enter-icon"]');
  const exitIcon = button.querySelector('[data-role="fullscreen-exit-icon"]');

  if (!enterIcon || !exitIcon) return;

  const isFullscreen = !!document.fullscreenElement;
  enterIcon.classList.toggle('hidden', isFullscreen);
  exitIcon.classList.toggle('hidden', !isFullscreen);
};

export const bindFullscreenIconRuntime = () => {
  document.addEventListener('fullscreenchange', () => {
    const button = document.getElementById('day-modal-fullscreen-btn');
    syncFullscreenButtonState(button);
  });
};

export const bindExternalNavigationRuntime = () => {
  window.addEventListener('phx:navigate_external', (e) => {
    if (e.detail && e.detail.url) {
      window.location.href = e.detail.url;
    }
  });
};

export const initializeBrowserRuntime = (liveSocket) => {
  configureTopbar();
  bindPageLoadingRuntime();
  bindConnectivityRuntime();
  enableLiveViewDebug(liveSocket);
  bindCloseDropdownRuntime();
  bindDownloadFileRuntime();
  bindFullscreenIconRuntime();
  bindExternalNavigationRuntime();
};
